import type { ChatRoomListResponsePageAllOfThreeContentItemParticipantsItemBasicInfo } from './chatRoomListResponsePageAllOfThreeContentItemParticipantsItemBasicInfo';
import type { ChatRoomListResponsePageAllOfThreeContentItemParticipantsItemSocial } from './chatRoomListResponsePageAllOfThreeContentItemParticipantsItemSocial';

/**
 * 간략한 사용자 정보
 */
export type ChatRoomListResponsePageAllOfThreeContentItemParticipantsItem = {
  /** 사용자 기본 정보 */
  basicInfo: ChatRoomListResponsePageAllOfThreeContentItemParticipantsItemBasicInfo;
  /** 소셜 관계 정보 */
  social?: ChatRoomListResponsePageAllOfThreeContentItemParticipantsItemSocial;
};
